import React, {useState} from "react";
import {MenuItem} from "navigation-common/types/navigation-types";
import InlineEdit from "@atlaskit/inline-edit";
import classNames from "classnames";
import {Box} from "@atlaskit/primitives";
import Textfield from "@atlaskit/textfield";
import ErrorIcon from "@atlaskit/icon/glyph/error";
import {token} from "@atlaskit/tokens";
import {R400} from "@atlaskit/theme/colors";
import {SecurityService} from "navigation-common/SecurityService";
import InlineDialog from "@atlaskit/inline-dialog";

interface CqlInputFieldProps {
    menuItem: MenuItem,
    changeTrigger: (cqlString: string) => void,
}

export const CqlInputField = (props: CqlInputFieldProps) => {
    const [cqlValue, setCqlValue] = useState<string>(props.menuItem.cqlString || "");

    const validate = async (value: string) => {
        const validateObject = await new Promise<{ value: string; error: string; } | undefined>(
            (resolve) => {
                if (SecurityService.isSafeCql(value)) {
                    resolve(undefined);
                }
                resolve({value, error: "Please do not use: \\ { } or empty"});
            });
        if (validateObject && validateObject.value === value) {
            return validateObject.error;
        }
        return undefined;
    };

    return (
        <InlineEdit readViewFitContainerWidth={true} defaultValue={cqlValue}
                    editView={({errorMessage, ...fieldProps}) => (
                        <InlineDialog
                            isOpen={fieldProps.isInvalid}
                            content={<Box id="error-message">{errorMessage}</Box>}
                            placement="top-start">
                            <Textfield {...fieldProps} autoFocus placeholder={"Start typing a CQL query"}
                                       elemAfterInput={
                                           fieldProps.isInvalid && (
                                               <Box>
                                                   <ErrorIcon
                                                       label="error"
                                                       primaryColor={token('color.icon.danger', R400)}
                                                   />
                                               </Box>
                                           )
                                       }
                            />
                        </InlineDialog>
                    )}
                    readView={() => (
                        <div className={classNames({"empty": !props.menuItem.cqlString})} data-testid="read-view" style={{marginTop: "2px"}}>
                            {props.menuItem.cqlString || 'Enter CQL query'}
                        </div>
                    )}
                    onConfirm={(cqlString) => props.changeTrigger(cqlString)}
                    hideActionButtons
                    validate={validate}
        />
    );
}
